import { render } from "./JobCard.vue?vue&type=template&id=2c36181b"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__